module.exports = __webpack_public_path__ + "static/media/error.1e9ac909.svg";